import * as actionTypes from './actionTypes';
import { priceService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { PaymentPriceModel } from '@app/src/views/StepPayment/formPayment/models/PaymentPriceModel';
import { hydrateData } from './hydrators';
import { fetchValidate } from '@app/src/common/session';

const fetchPriceRequest = () => ({
  type: actionTypes.FETCH_PRICE_REQUEST
});

const fetchPriceFailure = () => ({
  type: actionTypes.FETCH_PRICE_FAILURE
});

const fetchPriceSuccess = (data: PaymentPriceModel) => ({
  type: actionTypes.FETCH_PRICE_SUCCESS,
  data
});

const formatData = (data) => data.data && data.data.length > 0 ? hydrateData(data.data[0]) : {};

export const fetchPrice = (categoryId: number, summaryId: string) => {
  return async dispatch => {
    dispatch(fetchPriceRequest());
    await dispatch(fetchValidate());
    try {
      const data = await priceService.getForPrint(categoryId, summaryId);
      if (data.error) {
        dispatch(actionsModalError.openModalError(data.data[0].message, data.data[0].redirect));
      } else {
        dispatch(fetchPriceSuccess(formatData(data)));
      }
    } catch (error) {
      dispatch(actionsModalError.openModalError());
      dispatch(fetchPriceFailure());
    }
  }
};

export const fetchPriceOpportunity = (uniqueId: string) => {
  return async dispatch => {
    dispatch(fetchPriceRequest());
    try {
      const data = await priceService.getForOpportunity(uniqueId);
      if (data.error) {
        dispatch(actionsModalError.openModalError(data.data[0].message, data.data[0].redirect));
      } else {
        dispatch(fetchPriceSuccess(formatData(data)));
      }
    } catch (error) {
      dispatch(actionsModalError.openModalError());
      dispatch(fetchPriceFailure());
    }
  }
}
